import template from './sw-cms-block-image-text-cover.html.twig';
import './sw-cms-block-image-text-cover.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
